export const bonuses = [
  {
    number: 1,
    title: "Self-Ligating Clinical Decision Atlas™",
    value: "$37",
    image: "https://cdn.magicpatterns.com/patterns/generated-images/1c402c79-fcc2-46c7-b4ff-344ce7fb83d2.jpg",
    description: "A visual educational atlas covering common decisions and considerations associated with self-ligating orthodontic systems.",
    includes: [
      "Active versus passive system comparisons",
      "Bracket mechanics illustrations",
      "Case assessment scenarios",
      "Treatment objective worksheets",
      "Clinical decision questions",
      "Educational diagrams",
    ],
    closing: "Use it to review important concepts when studying or discussing cases.",
  },
  {
    number: 2,
    title: "Archwire Selection Reference Guide™",
    value: "$27",
    image: "https://cdn.magicpatterns.com/patterns/generated-images/b32b2806-2010-4548-8fb0-72e2f2ae3c70.jpg",
    description: "A structured reference for understanding orthodontic archwire properties and their biomechanical implications.",
    includes: [
      "Material comparison tables",
      "Wire dimension references",
      "Mechanical property summaries",
      "Force-system illustrations",
      "Clinical considerations",
      "Reference worksheets",
    ],
    closing: "Designed to make complex archwire concepts easier to review.",
  },
  {
    number: 3,
    title: "Self-Ligating Biomechanics Visual Casebook™",
    value: "$29",
    image: "https://cdn.magicpatterns.com/patterns/generated-images/20a843b9-ccba-4add-8280-4d4b88a2faf2.jpg",
    description: "A collection of illustrated educational scenarios focused on bracket mechanics, tooth movement, and anchorage considerations.",
    includes: [
      "Biomechanical illustrations",
      "Movement analysis exercises",
      "Anchorage scenarios",
      "Clinical reasoning questions",
      "Treatment sequencing examples",
      "Case discussion worksheets",
    ],
    closing: "Each scenario encourages you to connect theoretical principles with practical clinical reasoning.",
  },
  {
    number: 4,
    title: "Orthodontic Troubleshooting Workbook™",
    value: "$27",
    image: "https://cdn.magicpatterns.com/patterns/generated-images/d9292be7-fb70-40ec-a018-24b21e822f8e.jpg",
    description: "An educational workbook focused on identifying and reviewing common challenges in fixed-appliance orthodontics.",
    includes: [
      "Progress review checklists",
      "Biomechanical troubleshooting questions",
      "Anchorage review worksheets",
      "Treatment deviation scenarios",
      "Reassessment frameworks",
      "Documentation templates",
    ],
    closing: "The goal is to support structured learning and clinical reflection.",
  },
  {
    number: 5,
    title: "One-Page Self-Ligating Treatment Planning Template™",
    value: "$27",
    image: "https://cdn.magicpatterns.com/patterns/generated-images/73913338-af01-47cd-b104-ba170b2bebd8.jpg",
    description: "A reusable worksheet for organizing the major elements of an orthodontic case.",
    includes: [
      "Patient assessment",
      "Diagnostic findings",
      "Treatment objectives",
      "Appliance considerations",
      "Anchorage requirements",
      "Biomechanical considerations",
      "Proposed treatment phases",
      "Monitoring and reassessment",
      "Finishing and retention",
    ],
    closing: "A simple visual format designed to support case discussions and educational planning.",
  },
];
